export const tableSettings = {
    pageRows: [10, 25, 50],
    rowsPerPage: 10,
};
